import ActionTypes from './ActionTypes';
const guestUpcomingEvents = payload => {
  return {
    type: ActionTypes.GUEST_UPCOMING_EVENTS,
    payload,
  };
};

const createWellWishing= payload => {
  return {
    type: ActionTypes.GUEST_EVENTS_WEDWALL,
    payload,
  };
};

const eventDatailsGuest= payload => {
  return {
    type: ActionTypes.GUEST_EVENTS_DETAIL,
    payload,
  };
};

const getGuestRsvpDetails = payload => {
  return {
    type: ActionTypes.GET_GUEST_RSVP_DETAILS,
    payload,
  };
};

const updateGuestRsvpEvent = payload => {
  return {
    type: ActionTypes.UPDATE_GUEST_RSVP_EVENT,
    payload,
  };
};

export {guestUpcomingEvents, getGuestRsvpDetails, updateGuestRsvpEvent,createWellWishing,eventDatailsGuest};
